<template>
    <div>
        <!-- import account -->
        <app-account></app-account>

        <!-- buying contents -->
        <div class="container">
            <template v-if="myBuyings">
                <div class="row">
                    <app-user-item v-for="(item, i) in myBuyings" :key="i" :item="item" :buying="true"></app-user-item>
                </div>
            </template>
            <template v-else>
                <div class="row my-5">
                    <div class="col-12 text-muted">
                        <center>
                            <i class="fas fa-box-open fa-5x my-3"></i>
                            <h5>You don't seem to have enquired nor bought any item yet, {{user.name | capitalize}}</h5>
                            <router-link :to="{ name: 'home' }" class="btn btn-dark-green my-5">
                                <i class="far fa-images"></i> Buy your first item here
                            </router-link>
                        </center>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Account from '../shared/Account.vue'
import UserItem from '../shared/UserItem.vue'
import LayoutUser from '@/layouts/User.vue'

export default {
    name: "Buying",
    methods: {
        ...mapActions(['itemsIamBuying']),
    },
    computed: {
        ...mapGetters(['user', 'buyings']),
        myBuyings() {
            if(this.buyings && this.buyings !== null){
                return this.buyings
            }
            return false
        },
    },
    components: {
        appUserItem: UserItem,
        appAccount: Account
    },
    created() {
        this.itemsIamBuying().then(() => {}).catch((e) => {})
        this.$emit('update:layout', LayoutUser);
    }
}
</script>